

<!-- <body> -->
    <div class="content">
        <div class="container-fluid">
            <div class="content box_shadow table_container">
                <span class="graphtitledata">Subject Details Report</span>
                <hr>
                <!-- <button (click)="onBtExport()"
                    style="margin-bottom: 5px; font-weight: bold;margin-left: 20px; margin-top: 5px; position: absolute;">
                    Download Excel</button> -->
                      <span (click)="onBtExport()"><img
                                                src="../../assets/image/vscode-icons_file-type-excel.svg"
                                                class="excel_sheet" alt=""></span>
                <input type="text " class="input " (input)="onQuickFilterChanged($event)" placeholder="Search..." />
                <ag-grid-angular  class="table_list"
                    [rowData]="rowData" [pinnedTopRowData]="pinnedTopRowData" [columnDefs]="colDefs"
                    [defaultColDef]="defaultColDef" [quickFilterText]="quickFilter"  [defaultExcelExportParams]="defaultExcelExportParams" (gridReady)="onGridReady($event)"/>
            </div>
        </div>
    </div>
<!-- </body> -->



<!-- Loading -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>